import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import {
    ReactFlow,
    Controls,
    ConnectionMode,
    type OnConnect,
    type Node,
    MiniMap,
    OnNodesChange,
    applyNodeChanges,
    useReactFlow
} from '@xyflow/react';

import '@xyflow/react/dist/style.css';

import '../../../assets/styles/componentStyles/flowBuilderStyles/flowBuilder.css'
import SelfConnectingEdge from './edges/selfConnectingEdge';
import BiDirectionalEdge from './edges/biDirectionalEdge';
import ButtonEdge from './edges/buttonEdge'
import trigger from './nodes/trigger';
import { Box, Divider, Fab, Fade, Grid, IconButton, Paper, TextField, Tooltip, Typography, useMediaQuery } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LeftSectionComponent from '../../dashboard/flowBuilder/leftSectionComponents/leftSectionComponent';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../context/flowBuilderContext';
import styles from './../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss'; 
import FlowBuilderNewNodeList from './flowBuilderNodeList';
import globalStyles from './../../../assets/styles/global.module.scss';
import GlobalButton from '../../utility/globalButton/button';
import { WorkflowContext, WorkflowContextPayload } from '../../../context/workflowContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import nodeWrapper from './nodes/nodeWrapper';
import agent from '../../../services/api';
import { getChatbotVersionInfo, isCurrentViewVersionPublished } from './utilityFunctions';
import { generateUUID, isAdmin } from '../../../utils/constants';
import { getChatbotChannelTheme, isInstagramChannel } from '../../../pages/ruleBasedInbox/channelConstants';
import { chatbot_step_type_id_webhook, contentNodes, initialNodes } from './flowBuilderConstants';
import { useFlowBuilderStore } from '../../../store/flowBuilderStore';
import GlobalPopUp from '../../utility/globalPopUp';
import PostDeploymentTrigger from './postDeploymentTrigger';
import ShowErrorPopup from './showErrorPopup';
import CreateVariablePopup from './leftSectionComponents/components/dataCollections/createVariablePopup';
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import { IntegrationContext, IntegrationContextPayload } from '../../../context/integrationContext';
import ArchiveIcon from '@mui/icons-material/Archive';

const edgeTypes = {
    bidirectional: BiDirectionalEdge,
    selfconnecting: SelfConnectingEdge,
    buttonedge: ButtonEdge,
};

const nodeTypes = {
    trigger: trigger,
    nodeWrapper: nodeWrapper,
};
const StaticWorkflowCanvas = () => {
    const [searchParams] = useSearchParams();
    const { nodes, setNodes, edges, setEdges, onEdgesChange, addNode,
        // GetCustomVariableListApi,
        APIQueList, setAPIQueList, updateNodeCoordinates, setUpdatedEdges, updateFlagStartNode, edgesLatestRef } = useContext(FlowBuilderContext) as FlowBuilderContextPayload

    const GetCustomVariableListApi = useFlowBuilderStore((state) => state.GetCustomVariableListApi)
    const GetMetaDataVariableListApi = useFlowBuilderStore((state) => state.GetMetaDataVariableListApi) 
    const flagHideArrows = useFlowBuilderStore((state) => state.flagHideArrows);
    const setFlagHideArrows = useFlowBuilderStore((state) => state.setFlagHideArrows);
    const flagInteractiveCanvas = useFlowBuilderStore((state) => state.flagInteractiveCanvas);
    const setFlagInteractiveCanvas = useFlowBuilderStore((state) => state.setFlagInteractiveCanvas);
    const setFlagDataCollectionPopup = useFlowBuilderStore((state) => state.setFlagDataCollectionPopup)
    const flagDataCollectionPopup = useFlowBuilderStore((state) => state.flagDataCollectionPopup)
    const setFlagUpdateFieldData = useFlowBuilderStore((state) => state.setFlagUpdateFieldData) 
    const flagDeleteFieldData = useFlowBuilderStore((state) => state.flagDeleteFieldData) 
    const existingCustomVariablePayload = useFlowBuilderStore((state) => state.existingCustomVariablePayload) 
    const setFlagDeleteData = useFlowBuilderStore((state) => state.setFlagDeleteData)
    const getChatbotTriggerConfigApi = useFlowBuilderStore((state) => state.getChatbotTriggerConfigApi)
    const getChatbotActionTypeApi = useFlowBuilderStore((state) => state.getChatbotActionTypeApi)
    const chatbotActionTypeData = useFlowBuilderStore((state) => state.chatbotActionTypeData);

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const { getWorkflowDetails, currentActiveStaticWorkflow, isProcessing } = useContext(WorkflowContext) as WorkflowContextPayload;
    const { currentActiveNodeConfig, setCurrentActiveNodeConfig, flagOpenFlowBuilderList, setFlagOpenFlowBuilderList, 
        generateNodesAndEdges, filteredNodes, setFilteredNodes, searchQuery, setSearchQuery, currentIndex, setCurrentIndex } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const { handleError, userDetail } = useContext(UserContext) as UserContextPayload
    const { getMetaIntegrationList, integrationListNewStructure } = useContext(IntegrationContext) as IntegrationContextPayload;
    const [flagOpenKeywordsPopup, setFlagOpenKeywordsPopup] = useState<boolean>(false);

    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
        flagLaptopScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1550px)'), 
        tabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 0px)'),
    }

    const [flagShowErrorPopup, setFlagShowErrorPopup] = useState<boolean>(false);  
    const [flagChangesNotSaveInBE, setFlagChangesNotSaveInBE] = useState<boolean>(false); 
    const [errorMessageWhenChangesNotSave, setErrorMessageWhenChangesNotSave] = useState<string>("");

    const [flowZoomPercent, setFlowZoomPercent] = useState<number>(breakPoints.flagLaptopScreen ? 50 : 75); //Default Zoom Level
    const lastZoom = useRef<number | null>(null);
    const searchInputRef = useRef<HTMLInputElement>(null);

    const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false);

    const { fitView, setCenter, screenToFlowPosition } = useReactFlow(); 

    const channelTheme = getChatbotChannelTheme(currentActiveStaticWorkflow?.chatbot_channel?.channel_name);

    const channelName = currentActiveStaticWorkflow?.chatbot_channel?.channel_name;
    const isInstagram = isInstagramChannel(channelName);
    
    const focusNode = (node: any) => {
        const x = node?.position?.x;
        const y = node?.position?.y;

        setCenter(x, y, {
            zoom: 1,
            duration: 800,
        });
    };

    useEffect(() => {
        const handleFullscreenChange = () => { // Fit React Flow Canvas on full screen change.
            setTimeout(() => {
                fitView({ padding: 0.2, duration: 100 }); 
            }, 10);
        };

        document.addEventListener("fullscreenchange", handleFullscreenChange);
        return () => {
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
        }
    }, [fitView]);

    const { setFlagLoading } = useContext(UserContext) as UserContextPayload;
    const navigate = useNavigate()
    const innerHeight = window.innerHeight - 80;
    const edgesRef = useRef(edges);
    const nodesRef = useRef(nodes)

    const onConnectEnd = useCallback(
        async (event: any, connectionState: any) => {
            // when a connection is dropped on the pane it's not on any node
            if (!connectionState.toNode) {
                const { clientX, clientY } =
                    'changedTouches' in event ? event.changedTouches[0] : event;
                let node = contentNodes(currentActiveStaticWorkflow)?.find((node) => node.type == 'nodeWrapper')
                let id = generateUUID()
                const newNode = {
                    ...node,
                    id,
                    position: screenToFlowPosition({
                        x: clientX,
                        y: clientY,
                    }),
                    origin: [0.5, 0.0],
                };
                await addNode(newNode, nodesRef.current, true)
                // setTimeout(() => {
                let params = {
                    source: connectionState.fromNode.id,
                    sourceHandle: connectionState.fromHandle.id,
                    targetHandle: id,
                    target: id
                }
                edgesConnect(params)
                // }, 200)

            }
        },
        [screenToFlowPosition],
    );

    useEffect(() => {
        edgesRef.current = edges;
        edgesLatestRef.current = edges;
    }, [edges]);

    useEffect(() => {
        nodesRef.current = nodes
    }, [nodes])

    function edgesConnect(params: any) {
        let isSourceTrigger = nodesRef.current.find((node: any) => node.type == 'trigger');
        if (params.source == isSourceTrigger.id) {
            let edgeAlreadyExist = false
            let prevTargetNode = null
            let prevTargetEdgeNode = edgesRef.current.find((edge: any) => edge.source == params.source)
            if (prevTargetEdgeNode) {
                prevTargetNode = nodesRef.current.find((node: any) => node.id == prevTargetEdgeNode.target)
            }
            let targetNodeData = nodesRef.current.find((node: any) => node.id == params.target)
            if (edgesRef.current && edgesRef.current.length > 0) {
                edgeAlreadyExist = edgesRef.current.find((edge: any) => edge.source == params.source && edge.target == params.target && edge.sourceHandle == params.sourceHandle && edge.targetHandle == params.targetHandle)
            }
            if (!edgeAlreadyExist) {
                setUpdatedEdges({
                    actionType: "addNewEdge",
                    edgeData: params
                },
                    nodesRef.current,
                    edgesRef.current);
                updateFlagStartNode(targetNodeData, prevTargetNode)
            }
        } else {
            let edgeAlreadyExist = false
            const sourceHandleParts = params.sourceHandle?.split('+') || [];
            params = {
                ...params,
                isCustomVariable: sourceHandleParts?.length > 1 ? true : null,    // Only for if source of edge is a condition. 
            }

            if (edgesRef.current && edgesRef.current.length > 0) {
                edgeAlreadyExist = edgesRef.current.find((edge: any) => edge.source == params.source && edge.target == params.target && edge.sourceHandle == params.sourceHandle && edge.targetHandle == params.targetHandle)
            }
            if (!edgeAlreadyExist) {
                setUpdatedEdges({
                    actionType: "addNewEdge",
                    edgeData: params
                },
                    nodesRef.current,
                    edgesRef.current,
                    true
                );

                //     updateNodeFlow({
                //         actionType: "addNewEdge",
                //         edgeData: params
                //     },
                //         nodesRef.current,
                //         edgesRef.current)
            }
        }
    }

    const onConnect: OnConnect = useCallback(
        (params) => {
            edgesConnect(params)
        },
        [],
    );
    const onNodesChange: OnNodesChange = useCallback(
        (changes) => {
            setNodes((nds: Node[]) => applyNodeChanges(changes, nds))
        },
        [setNodes],
    );
    const onNodeDragStop: any = useCallback(
        (event: any, changes: any) => {
            if (changes.type == 'trigger') {
            } else {
                if (!isCurrentViewVersionPublished(currentActiveStaticWorkflow)) {
                    updateNodeCoordinates(changes)
                }
            }
        },
        [setNodes],
    );

    // Collapse incremental update_step_flow snapshots into one activity per step (full final flow array).
    const coalesceUpdateStepFlowActivities = (activities: any[] = []) => {
        const lastIndexByStepId = new Map<string, number>();
        activities.forEach((item, index) => {
            if (item?.activity_type === "update_step_flow" && item?.chatbot_step_id) {
                lastIndexByStepId.set(item.chatbot_step_id, index);
            }
        });

        return activities.reduce((acc: any[], item: any, index: number) => {
            if (item?.activity_type !== "update_step_flow") {
                acc.push(item);
                return acc;
            }
            if (lastIndexByStepId.get(item.chatbot_step_id) !== index) {
                return acc;
            }
            const seenFlowIds = new Set<string>();
            acc.push({
                ...item,
                chatbot_step_flow: (item.chatbot_step_flow || []).filter((flow: any) => {
                    const flowId = flow?.chatbot_step_flow_id;
                    if (!flowId || seenFlowIds.has(flowId)) {
                        return false;
                    }
                    seenFlowIds.add(flowId);
                    return true;
                })
            });
            return acc;
        }, []);
    };

    const apiCall = async (payload: any): Promise<{response: any, status: boolean}> => {
        let stepPayload = {
            payload: coalesceUpdateStepFlowActivities(payload)
        }
        const response = await agent.batchUpdateChatbotSteps.put(currentActiveStaticWorkflow?.chatbot_id || "", stepPayload) 
        const status = response.status;
        return {response, status};
        // new Promise((resolve) => {
        //     setTimeout(() => {
        //         console.log("API called with:", payload);
        //         resolve(true); // Simulate success
        //     }, 1000);
        // });
    };

    useEffect(() => {
        if (
            !isProcessing.current &&
            APIQueList.filter((api: any) => !api.flag_saved_in_BE).length > 0) processQueue();
    }, [APIQueList, isProcessing]);

    const processQueue = async () => {
        if (
            isProcessing.current ||
            APIQueList.filter((api: any) => !api.flag_saved_in_BE).length === 0) return;
        let ApiQueListTemp = [...APIQueList.filter((api: any) => !api.flag_saved_in_BE)]

        isProcessing.current = true;
        while (ApiQueListTemp.filter((api: any) => !api.flag_saved_in_BE).length > 0) {
            let payload = [...ApiQueListTemp]
            // const [firstItem, ...rest] = ApiQueListTemp;
            const {response, status} = await apiCall(payload);
            if (!status) { 
                if(isAdmin(userDetail)){
                    setErrorMessageWhenChangesNotSave(response?.error?.message)
                }
                if(response?.error?.code){ // Something went wrong from ourside.
                    setFlagChangesNotSaveInBE(true);
                }
                setFlagShowErrorPopup(true);
            } else {
                ApiQueListTemp.map((step: any) => {
                    setNodes((prevstate: any) => {
                        return prevstate.map((node: any) => {
                            if (node.id == step.chatbot_step_id) {
                                return {
                                    ...node,
                                    data: node.data.map((action: any) => {
                                        if (step.chatbot_step_action?.find((apiCallAction: any) => apiCallAction.chatbot_step_action_id == action.chatbot_step_action_id)) {
                                            return {
                                                ...action,
                                                flag_saved_in_BE: true
                                            } 
                                        } else {
                                            return {
                                                ...action,
                                                flag_saved_in_BE: false
                                            }
                                        }
                                    })
                                }
                            }
                            return node
                        });
                    });
                })
            }
            const updatedList = ApiQueListTemp.map(
                (item: any) => {
                    // payload.some((p: any) => item.chatbot_step_id === p.chatbot_step_id && item.activity_type == p.activity_type)
                    if (payload.some((p: any) => JSON.stringify(item) == JSON.stringify(p))) {
                        return {
                            ...item,
                            flag_saved_in_BE: true
                        }
                    }
                    return item
                }

            );
            ApiQueListTemp = updatedList;
            setAPIQueList((prevState: any) => {
                return prevState.map((item: any) => {
                    if (updatedList.some((p: any) => payload.some((p: any) => JSON.stringify(item) == JSON.stringify(p)))) {
                        return { ...item, flag_saved_in_BE: true }
                    }
                    return item
                })
            });
            // ApiQueListTemp = [];
            // setAPIQueList([updatedList]);
        }
        isProcessing.current = false;
    };

    const handleLeftPanelData = () => {
        if (currentActiveNodeConfig.flagOpenConfigForm) {
            setCurrentActiveNodeConfig((prevstate: any) => ({ ...prevstate, flagOpenConfigForm: false, nodeId: null, data: [], flag_initial: false, flag_trigger: false }))
        }
    }

    const handleOpenNodesList = () => {
        setFlagOpenFlowBuilderList(!flagOpenFlowBuilderList)
    }

    const handleKeywordsButtonClick = () => {
        setFlagOpenKeywordsPopup(true);
    }

    async function getCurrentActiveWorkflowDetails() {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));

        const workflow_id = searchParams.get('workflow_id');
        if (!workflow_id) {
            navigate('/workflow');
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
            return;
        }

        try {
            const workflowPromise = getWorkflowDetails(workflow_id);

            const otherPromises: any[] = [GetCustomVariableListApi(workflow_id), GetMetaDataVariableListApi(), getChatbotTriggerConfigApi(workflow_id)];

            if (!chatbotActionTypeData) {
                otherPromises.push(getChatbotActionTypeApiCall());
            }

            if (!integrationListNewStructure) {
                otherPromises.push(getIntegrationListApiCall());
            }

            const [workflowResponse] = await Promise.all([workflowPromise, ...otherPromises]);

            if (workflowResponse?.status && workflowResponse?.data) {
                // generateNodesAndEdges(workflowResponse.data[0]);
            } else {
                handleError(workflowResponse);
                navigate('/workflow');
            }
        } catch (error) {
            console.error("Error in getCurrentActiveWorkflowDetails:", error);
        } finally {
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        }
    }
    
    const getChatbotActionTypeApiCall = async () => {
        const res = await getChatbotActionTypeApi();
        if(!(res.status)){
            handleError(res);
        }
    } 

    const getIntegrationListApiCall = async () => {
        const res = await getMetaIntegrationList(true)
        if (!(res.status)) {
            handleError(res);  
        }
    }

    useEffect(() => {  
        getCurrentActiveWorkflowDetails()
        return () => {
            setFlagHideArrows(true);  // Reset Hide Arrow Flag
            setCurrentActiveNodeConfig((prev: any) => { // Close Left Section Component
                return {
                    ...prev, 
                    flagOpenConfigForm: false, 
                    nodeId: null, 
                    data: [], 
                    flag_initial: false, 
                    flag_trigger: false,
                }
            }); 
            setFlagInteractiveCanvas(true);
            setSearchQuery('');
            setCurrentIndex(0);
            setFilteredNodes([]);
            setNodes(initialNodes);
            setEdges([]);
        }
    }, [searchParams])

    useEffect(() => {
        if (currentActiveStaticWorkflow) {
            generateNodesAndEdges(currentActiveStaticWorkflow)
        }
    }, [currentActiveStaticWorkflow?.currentViewVersion])
    
    const isValidConnection = (connection: any) => {

        let existingEdges = edgesRef.current.filter((edge: any) => edge.source == connection.source && edge.target == connection.target)
        if (existingEdges.length > 0) {
            if (connection.source == connection.sourceHandle) {  //the connection is not from a button
                return !existingEdges.some((edge: any) => edge.source !== edge.sourceHandle) //connection already exist through a button
            } else {
                return !existingEdges.some((edge: any) => edge.source == edge.sourceHandle)
            }
        }
        let targetNode = nodes.find((node: any) => node.id == connection.target)
        let sourceNode = nodes.find((node: any) => node.id == connection.source)
        let checkIfTargetNodeIsWebhook = targetNode?.chatbot_step_type_id ? targetNode?.chatbot_step_type_id == chatbot_step_type_id_webhook : false
        if (checkIfTargetNodeIsWebhook) {
            if (sourceNode.id !== connection.sourceHandle) {// not an interactive component
                let nodeHasSaveVariableAction = Array.isArray(sourceNode?.data) ? sourceNode.data.some((action: any) => action.action_type?.action_type_name == "save_variable") : false
                if (nodeHasSaveVariableAction) {
                    return false;
                } else {
                    return false;
                }
            } 
        }
        return true
    };
    
    const onMoveOfFlow = (_: any, viewport: { zoom: number }) => {
        if(viewport.zoom != lastZoom.current){
            lastZoom.current = viewport.zoom;
            
            const zoomPercent = Math.round(viewport.zoom * 100);
            setFlowZoomPercent(zoomPercent);
        }
    }
 
    const handleNodeDraggable = () => {
        if(isCurrentViewVersionPublished(currentActiveStaticWorkflow)){
            return false;
        }
        return flagInteractiveCanvas;
    }

    const handleDeleteFieldData = async () => {
        setFlagLoading((prevState) => { return { ...prevState, flagRoundLoader: true } });
        const res = await agent.deleteChatbotCustomVariable.delete(existingCustomVariablePayload.chatbot_custom_variable_config_id)
        if (res.status) {
            showSuccess("Field Archived Successfully")
            await GetCustomVariableListApi(searchParams.get('workflow_id') ?? "")
        }
        else {
            handleError(res);
        }
        setFlagLoading((prevState) => { return { ...prevState, flagRoundLoader: false } });
    }

    useEffect(() => {
        if (!searchQuery) {
            setFilteredNodes([]);
            setCurrentIndex(0);
            return;
        }

        const matchedNodes = nodes.filter((node: any) => node?.chatbot_step_name?.toLowerCase().includes(searchQuery?.toLowerCase()) && node?.type === "nodeWrapper");

        setFilteredNodes(matchedNodes);
        setCurrentIndex(0);
    }, [searchQuery, nodes]);

    const goToNextNode = () => {
        if (!filteredNodes?.length) return;

        const nextIndex = (currentIndex + 1) % filteredNodes?.length;
        setCurrentIndex(nextIndex);
        focusNode(filteredNodes[nextIndex]);
    };

    const goToPrevNode = () => {
        if (!filteredNodes?.length) return;

        const prevIndex =
            (currentIndex - 1 + filteredNodes?.length) % filteredNodes?.length;

        setCurrentIndex(prevIndex);
        focusNode(filteredNodes[prevIndex]);
    };

    const handleSearchClose = () => {
        setIsSearchOpen(false);
        setSearchQuery('');
        setFilteredNodes([]);
        setCurrentIndex(0);
    }

    return (
        <>
            <GlobalPopUp
                open={flagOpenKeywordsPopup}
                onClose={() => { setFlagOpenKeywordsPopup(false); }}
                handleClose={() => { setFlagOpenKeywordsPopup(false); }}
                flagShowCloseIcon={true}
                paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "1150px"}
                paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "1150px"}
                borderRadius='10px'
                titlePadding='0px'
                overflow="hidden"
            >
                <PostDeploymentTrigger
                    setFlagOpenKeywordsPopup={setFlagOpenKeywordsPopup}
                />
            </GlobalPopUp>
            <GlobalPopUp
                open={flagShowErrorPopup}
                onClose={() => { setFlagShowErrorPopup(false); setFlagChangesNotSaveInBE(false); setErrorMessageWhenChangesNotSave("")}}
                handleClose={() => { setFlagShowErrorPopup(false); setFlagChangesNotSaveInBE(false); setErrorMessageWhenChangesNotSave("")}}
                paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "600px"}
                paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "700px"}
                borderRadius='10px'
                titlePadding='0px'
                overflow="hidden" 
                flagBackdrop
            >
                <ShowErrorPopup 
                    flagChangesNotSaveInBE={flagChangesNotSaveInBE} 
                    errorMessageWhenChangesNotSave={errorMessageWhenChangesNotSave}
                />
            </GlobalPopUp> 

            {flagDataCollectionPopup &&
                <GlobalPopUp
                    open={flagDataCollectionPopup}
                    onClose={() => { setFlagDataCollectionPopup(false); setFlagUpdateFieldData(false) }}
                    flagBackdrop
                    paperMinWidth={breakPoints.tabletScreen ? "310px" : "700px"}
                    paperMaxwidth={breakPoints.tabletScreen ? "610px" : "750px"}
                    flagShowCloseIcon={true}
                    titlePadding='0'
                    handleClose={() => { setFlagDataCollectionPopup(false); setFlagUpdateFieldData(false) }}
                >
                    <CreateVariablePopup />
                </GlobalPopUp>
            } 

            {flagDeleteFieldData &&
                <GlobalDeletePopup
                    icon={<ArchiveIcon className={globalStyles.deleteConfirmImage} />}
                    title="Archive Field"
                    deleteDescription={`Are you sure you want to archive ${existingCustomVariablePayload.chatbot_custom_variable_name} field`}
                    open={flagDeleteFieldData}
                    onClose={() => { setFlagDeleteData(false) }}
                    onDelete={() => {
                        handleDeleteFieldData()
                        setFlagDeleteData(false)
                    }}
                    primaryButtonText="Archive"
                />
            }
            <Grid container sx={{ position: "relative", flexWrap: "nowrap", height: `${innerHeight}px !important`, maxHeight: `${innerHeight}px !important`, overflow: "auto" }} direction={"column"}>
                <Grid item sx={{ width: "100%", height: "100%" }}>
                    <Grid container sx={{ height: "100%", width: "100%", backgroundColor: "#FEFEFE", position: "relative", flexWrap: "nowrap", touchAction: "none !important" }}>
                        {!isCurrentViewVersionPublished(currentActiveStaticWorkflow) ?
                            <Grid item className={styles.floatingIconStyles} onClick={() => { if(flagInteractiveCanvas) handleOpenNodesList()}}>
                                <Grid container flexWrap={"nowrap"} gap={1}>
                                    <Grid item onClick={() => handleLeftPanelData()} className={`${styles.nodeListContainer} ${flagOpenFlowBuilderList == true ? styles.openListContainer : flagOpenFlowBuilderList == false ? styles.closeListContainer : ""}`} mt={3}>
                                        <FlowBuilderNewNodeList 
                                            nodesRef={nodesRef.current} 
                                            addNode={addNode}
                                        />
                                    </Grid>
                                    
                                    <Fab color="secondary" aria-label={flagOpenFlowBuilderList ? "close" : "add"} className={styles.nodeActionIcons} disabled={!flagInteractiveCanvas}>
                                        {flagOpenFlowBuilderList ? <CloseIcon /> : <AddIcon />}
                                    </Fab>
                                </Grid>
                            </Grid>
                            :
                            <>
                            {!isInstagram && (
                                getChatbotVersionInfo(currentActiveStaticWorkflow, userDetail).status.toLowerCase() === "published" &&
                                    <Grid item className={`${styles.floatingIconStyles} ${globalStyles.zIndex1}`}>
                                        <GlobalButton
                                            buttonText="Keyword-Based Routing"
                                            className='primaryButtonStyle'
                                            sx={{ width: "220px" }}
                                            onClick={() => handleKeywordsButtonClick()}
                                        />
                                    </Grid>
                                )}
                            </>
                        }
                        
                        {!(isCurrentViewVersionPublished(currentActiveStaticWorkflow) && getChatbotVersionInfo(currentActiveStaticWorkflow, userDetail).status.toLowerCase() !== "published") &&
                            <Grid item className={`${styles.searchFloatingIconStyles} ${isCurrentViewVersionPublished(currentActiveStaticWorkflow) && isInstagram ? styles.searchFloatingIconAtTop : ""}`}>
                                <Paper
                                    elevation={isSearchOpen ? 6 : 2}
                                    onClick={() => !isSearchOpen && setIsSearchOpen(true)}
                                    className={`${styles.searchPaper} ${isSearchOpen ? styles.searchPaperOpen : styles.searchPaperClosed}`}
                                >
                                    {/* Search Icon / Start State */}
                                    <Box className={styles.searchIconBox}>
                                        <SearchIcon className={styles.searchIconColor} />
                                    </Box>

                                    {/* Expanded UI */}
                                    <Fade in={isSearchOpen} onEntered={() => searchInputRef.current?.focus()}>
                                        <Box className={styles.searchExpandedBox}>
                                            <TextField
                                                variant="standard"
                                                inputRef={searchInputRef}
                                                autoFocus={isSearchOpen}
                                                placeholder="Search step..."
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') goToNextNode();
                                                    if (e.key === 'Escape') handleSearchClose();
                                                }}
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                                className={styles.searchTextField}
                                            />
                                            
                                            <Typography variant="caption" className={styles.searchMatchCount}>
                                                {filteredNodes?.length > 0 ? `${currentIndex + 1}/${filteredNodes?.length}` : '0/0'}
                                            </Typography>

                                            <Divider className={styles.searchDivider} orientation="vertical" />

                                            <Tooltip title="Previous Match">
                                                <IconButton size="small" onClick={() => goToPrevNode()} disabled={filteredNodes?.length === 0}>
                                                    <KeyboardArrowUpIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>

                                            <Tooltip title="Next Match">
                                                <IconButton size="small" onClick={() => goToNextNode()} disabled={filteredNodes?.length === 0}>
                                                    <KeyboardArrowDownIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>

                                            <Tooltip title="Close Search">
                                                <IconButton size="small" onClick={() => handleSearchClose() } className={styles.searchCloseButton}>
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </Fade>
                                </Paper>
                            </Grid>
                        }

                        <Grid item sx={{ height: "100%" }}>
                            <Grid container sx={{ position: "relative", height: "100%" }}>
                                <LeftSectionComponent />
                            </Grid>
                        </Grid>

                        <Grid item sx={{ width: "100%", backgroundColor: "#FEFEFE", position: "relative" }} marginLeft={"58px"} onClick={() => handleLeftPanelData()}>
                            {isCurrentViewVersionPublished(currentActiveStaticWorkflow) && getChatbotVersionInfo(currentActiveStaticWorkflow, userDetail).status.toLowerCase() !== "published" ?
                                <Grid container className={globalStyles.fullHeight} justifyContent={"center"} alignItems={"center"}>
                                    You haven't published your flow yet!
                                </Grid>
                                : 
                                <>
                                    <ReactFlow
                                        nodes={nodes}
                                        edges={edges}
                                        onNodesChange={onNodesChange}
                                        onNodeDragStop={onNodeDragStop}
                                        onEdgesChange={onEdgesChange}
                                        onConnect={(params) => {
                                            if(!flagInteractiveCanvas) return;
                                            onConnect(params);
                                        }}
                                        onConnectEnd={(event, connectionState) => {
                                            if(!flagInteractiveCanvas) return;
                                            onConnectEnd(event, connectionState);
                                        }}
                                        snapToGrid={true}
                                        edgeTypes={edgeTypes}
                                        nodeTypes={nodeTypes}
                                        // fitView
                                        proOptions={{ hideAttribution: true }}
                                        attributionPosition="top-right"
                                        connectionMode={ConnectionMode.Loose}
                                        style={{
                                            backgroundColor: "#F7F9FB",
                                            ["--channel-color" as any]: channelTheme.color,
                                            ["--channel-glow-color" as any]: channelTheme.glowColor,
                                        }}
                                        className={`${styles.canvasFlowStyle} ${flagHideArrows ? `${styles.hideArrows}` : ""}`}
                                        isValidConnection={isValidConnection}
                                        onMoveEnd={onMoveOfFlow}  
                                        nodesDraggable={handleNodeDraggable()}
                                        minZoom={0.25} // Minimum Zoom 25%
                                        defaultViewport={{ x: 0, y: 0, zoom: breakPoints.flagLaptopScreen ? 0.50 : 0.75 }} // Default Zoom for laptop screen is 50% and for desktop screen is 75% 
                                    >
                                        <MiniMap
                                            // nodeStrokeColor={(n: any) => {
                                            //     if (n.type === 'trigger') return '#0041d0';
                                            //     if (n.type === 'nodeWrapper') return 'red';
                                            //     if (n.type === 'output') return '#ff0072';
                                            // }}
                                            nodeColor={(n: any) => {
                                                if (n.type === 'trigger') return 'green';
                                                return '#ebab34';
                                            }}
                                            pannable
                                            zoomable />
                                        <Controls 
                                            position={"bottom-right"} 
                                            onInteractiveChange={(interactive) => { // This function calls when you lock or unlock the canvas.
                                                setFlagInteractiveCanvas(interactive);
                                            }}
                                        />
                                        {/* <Background /> */}
                                    </ReactFlow> 
                                    <div className={styles.flowZoomPercent}>
                                        {flowZoomPercent}%
                                    </div>
                                </>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default StaticWorkflowCanvas;